import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import type {LoginResponse} from "../../types/auth";

export type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
};

const initialState: AuthState = {
  accessToken: localStorage.getItem("accessToken"),
  refreshToken: localStorage.getItem("refreshToken"),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials(state, action: PayloadAction<LoginResponse>) {
      const {accessToken, refreshToken} = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      // store token in localStorage or state manager
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
    },
    logout(state) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      state.accessToken = null;
      state.refreshToken = null;
    },
  },
});

export const {setCredentials, logout} = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectIsAuthenticated = (s: { auth: AuthState }) => {
  return s.auth.accessToken != null;
}

export const selectAccessToken = (s: { auth: AuthState }) => {
  return s.auth.accessToken;
}